<template>
  <div class="theme-picker-step">
    <h2 class="step-title">Choose Your Setting</h2>
    <p class="step-sub">Every mystic works from somewhere. Where does your energy live?</p>

    <div class="theme-grid">
      <button
        v-for="t in themes"
        :key="t.key"
        class="theme-tile"
        :class="{ selected: selectedTheme === t.key }"
        @click="pickTheme(t)"
      >
        <span class="theme-glyph">{{ t.glyph }}</span>
        <span class="theme-name">{{ t.label }}</span>
        <span class="theme-desc">{{ t.description }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const emit = defineEmits(['theme-chosen', 'context-signal'])

const themes = [
  { key: 'forest', label: 'Forest Oracle', glyph: '\u{1F332}', description: 'Ancient woods, mossy stones, lantern light between the trees.' },
  { key: 'city', label: 'City Sage', glyph: '\u{1F306}', description: 'Rooftop twilight, neon softened by rain, wisdom in the hum.' },
  { key: 'coastal', label: 'Coastal Guide', glyph: '\u{1F30A}', description: 'Salt air, tide pools, the rhythm of waves as counsel.' },
  { key: 'desert', label: 'Desert Wanderer', glyph: '\u{1F3DC}\uFE0F', description: 'Starlit dunes, campfire glow, silence that speaks volumes.' },
  { key: 'celestial', label: 'Celestial Mystic', glyph: '\u{2728}', description: 'Observatory domes, star charts, moonlit instruments of knowing.' },
  { key: 'library', label: 'Sacred Library', glyph: '\u{1F4DA}', description: 'Candlelit study, towering shelves, antique maps and ink.' },
]

const selectedTheme = ref(null)

function pickTheme(t) {
  selectedTheme.value = t.key
  emit('context-signal', {
    panel: 'studio', view: 'theme_step', interaction: 'theme_selected',
    data: { theme: t.key, label: t.label },
  })
  setTimeout(() => {
    emit('theme-chosen', { theme: t.key, label: t.label })
  }, 300)
}
</script>

<style scoped>
.theme-picker-step { color: #E8D8FF; }
.step-title {
  font-family: 'Cinzel', serif; font-size: 24px; font-weight: 600; color: #FFDFA3;
  margin: 0 0 8px; padding: 0; border: none; border-radius: 0;
  background: none; box-shadow: none; text-align: left;
}
.step-sub { font-size: 13px; color: rgba(255,255,255,0.45); line-height: 1.65; margin-bottom: 24px; }
.theme-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.theme-tile {
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  padding: 20px 12px; background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.08); border-radius: 12px;
  cursor: pointer; transition: all 0.25s; text-align: center;
  font-family: inherit;
}
.theme-tile:hover { border-color: rgba(201,169,78,0.35); }
.theme-tile.selected {
  background: rgba(201,169,78,0.08); border-color: rgba(201,169,78,0.6);
  box-shadow: 0 0 12px rgba(201,169,78,0.15);
}
.theme-glyph { font-size: 28px; }
.theme-name {
  font-family: 'Cinzel', serif; font-size: 14px; font-weight: 600;
  color: #FFDFA3;
}
.theme-desc { font-size: 11px; color: rgba(255,255,255,0.4); line-height: 1.5; }
</style>
